import script from "./ConfirmDeletePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeletePopup.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDeletePopup.vue?vue&type=style&index=0&id=43f31411&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f31411"]])

export default __exports__